import React from "react";
import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

// Pages
import HomePage from "./pages/HomePage";
import ProductDetailPage from "./pages/ProductDetailPage";

function App() {
  return (
    <div className="app-container">
      <HashRouter>
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/produto/:productId" element={<ProductDetailPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </HashRouter>
    </div>
  );
}

export default App;
